(function() {
    var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

    window.CustomSelect = (function() {
        function CustomSelect(ref) {
            this.ref = ref;
            this.setValue = bind(this.setValue, this);
            this.openSelect = bind(this.openSelect, this);
            this.optionSelected = this.ref.find('.j-selected');
            this.option = this.ref.find('.j-option');
            if (Modernizr.touchevents && !this.ref.hasClass('j-mobileCustom')) {
                this.ref.find('.customSelected__icon').remove();
                this.ref.find('.j-selected').remove();
                this.ref.find('.j-options').remove();
                this.ref.find('.j-realSelect').show();
            } else {
                this.optionSelected.click((function(_this) {
                    return function(e) {
                        e.preventDefault();
                        return _this.openSelect($(e.currentTarget));
                    };
                })(this));
                this.option.click((function(_this) {
                    return function(e) {
                        var optionClicked;
                        optionClicked = $(e.currentTarget);
                        e.preventDefault();
                        if (optionClicked.closest('.j-customSelect').hasClass('open')) {
                            return _this.setValue($(optionClicked));
                        }
                    };
                })(this));
                this.ref.on('close', (function(_this) {
                    return function(e) {
                        $(e.currentTarget).find('.j-options').removeClass('open');
                        return $(e.currentTarget).removeClass('open');
                    };
                })(this));
                document.addEventListener('keydown', (function(_this) {
                    return function(e) {
                        var __newSelected, __options, __selected, i, keyCode, num, option;
                        __options = _this.ref.find('.open');
                        keyCode = e.keyCode || e.which;
                        option = __options.children();
                        if (__options.length > 0) {
                            if (__options.find('.selected').length > 0) {
                                __selected = __options.find('.selected');
                                num = __selected.index();
                            } else {
                                __selected = $(__options.find('.j-option')[0]);
                                num = -1;
                            }
                            switch (keyCode) {
                                case 38:
                                    e.preventDefault();
                                    i = num - 1;
                                    if (i > -1) {
                                        __newSelected = $(option[i]);
                                        __newSelected.siblings().removeClass('selected');
                                        __newSelected.addClass('selected');
                                        return __selected = __newSelected;
                                    }
                                    break;
                                case 40:
                                    e.preventDefault();
                                    i = num + 1;
                                    if (i < option.length) {
                                        __newSelected = $(option[i]);
                                        __newSelected.siblings().removeClass('selected');
                                        __newSelected.addClass('selected');
                                        return __selected = __newSelected;
                                    }
                                    break;
                                case 13:
                                    return _this.setValue(__selected);
                                case 27:
                                    __options.removeClass('open');
                                    return __options.closest('.j-customSelect').removeClass('open');
                            }
                        }
                    };
                })(this));
            }
        }

        CustomSelect.prototype.openSelect = function(btn) {
            var __options;
            this.ref.siblings().trigger('close');
            __options = btn.closest('.j-customSelect').find('.j-options');
            __options.toggleClass('open');
            return this.ref.toggleClass('open');
        };

        CustomSelect.prototype.setValue = function(option) {
            var __selected, _cs, realSelect;
            option.siblings().removeClass('active');
            option.siblings().removeClass('selected');
            option.addClass('active');
            option.addClass('selected');
            this.__value = option.text();
            __selected = option.closest('.j-customSelect').find('.j-selected');
            if (__selected.hasClass('js-tabTitle')) {
                __selected.find('.j-selectedValue').text(this.__value);
            } else {
                __selected.text(this.__value);
            }
            this.__dataValue = option[0].getAttribute('data-value');
            realSelect = option.closest('.j-customSelect').find('.j-realSelect');
            $(realSelect).find('.j-selectOption').attr('selected', false);
            $(realSelect).find('.j-selectOption[value="' + this.__dataValue + '"]').attr('selected', true);
            _cs = option.closest('.j-customSelect');
            _cs.trigger('close');
            if (_cs.hasClass('j-filtertab')) {
                option.closest('.j-options').removeClass('open');
                _cs.find('.j-selected').removeClass('active');
                _cs.find('.tab').removeClass('active');
                return _cs.removeClass('open');
            }
        };
        
        return CustomSelect;

    })();

}).call(this);